import { useStackNavigate } from '@/app/navigation/stack-links';
import type { MyWorkordersView } from '@/features/user-preferences/user-preferences.hooks';
import { DateNavigation } from '../../components/DateNavigation';

interface WorkorderNavigationProps {
  date: string;
  mode: MyWorkordersView;
}

export function WorkorderNavigation({ date, mode }: WorkorderNavigationProps) {
  const navigate = useStackNavigate();

  const handleDateChange = (newDate: string) => {
    navigate({
      to: '/my-workorders/$date',
      params: { date: newDate },
    });
  };

  return <DateNavigation date={date} onChange={handleDateChange} mode={mode} />;
}
